import { gql } from '@apollo/client';

export const fetchSandboxForEntitlement = gql`
  query fetchSandboxForEntitlement($id: String!, $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!) {
    entitlementDetails(id: $id) {
      id
      transactionAccountId
      sandboxEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        entitlementId
        billingFrequency
        productId
        baseProduct
        billingStatus
        entitlementNumber
        productName
        transactionAccountId
        billingGroupId
        billedUsers
        latestPeriodEndDate
        edition
        cloudSiteHostname
        trial
        isApp
        activeUsers
        relatesFromEntitlements {
          entitlementId
          relationshipType
        }
      }
    }
  }
`;
